import styled, { keyframes } from "styled-components";

import * as mq from "../styles/mediaQueries";

const fadeInDown = keyframes`

   0% {
      opacity: 0;
      transform: translateY(-100px);
   }
   100% {
      opacity: 1;
      transform: translateY(0);
   
} 
`;
const fadeInUp = keyframes`

   0% {
      opacity: 0;
      transform: translateY(40px);
   }
   100% {
      opacity: 1;
      transform: translateY(0);
   
} 
`;
const fadeInLeft = keyframes`

   0% {
      opacity: 0;
      transform: translateX(-150px);
   }
   100% {
      opacity: 1;
      transform: translateX(0);
   
} 
`;

export const RadioProceed = styled.button`
  appearance: none;
  position: relative;
  z-index: 1;
  border: none;
  background-color: #0de49d;
  border: 2px solid #0de49d;
  line-height: 2.67em;
  padding: 0px 35px;
  font-size: 1.2em;
  text-transform: capitalize;
  text-align: center;
  font-weight: 500;
  border-radius: 6px;
  color: #fff;
  min-width: 9.3em;
  animation: ${fadeInLeft} 1s both;
  /* animation-delay: 1.5s; */
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 1.87em;

    background-color: #fff;
    transition: all 0.3s ease-in-out;
    transform: scale(0, 1);
    z-index: -1;
  }

  &:hover {
    color: #0de49d;
    &:before {
      transform: scale(1) !important;
    }
  }
`;

export const H1label = styled.h1`
  padding: 0.6em 0px;
  font-size: 3.76em;
  line-height: 1.2;
  color: #2a2a2a;
  text-align: center;
  font-weight: normal !important;
  text-decoration: none;
  font-family: "Baskervville";

  animation: ${fadeInDown} 1s both;
  animation-delay: 0.4s;

  ${mq.sm} {
    font-size: 2rem;
    line-height: normal;
  }
`;

export const Paragraphlabel = styled.p`
  font-size: 1.43em;
  color: #929292;
  text-align: center;
  padding-bottom: 0.39em;
  font-weight: normal;
  animation: ${fadeInUp} 1s both;
  animation-delay: 0.9s;
`;
